module.exports = __webpack_public_path__ + "img/basket2-fill.679e735a.svg";